import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnInit,
} from '@angular/core';

import { PageWithHeaderController } from 'presentation/common/component/page-with-header/page-with-header.controller';
import { PageWithHeaderStore } from 'presentation/common/component/page-with-header/page-with-header.store';

@Component({
	selector: 'spr-page-with-header',
	templateUrl: './page-with-header.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [PageWithHeaderStore, PageWithHeaderController],
	host: {
		class: 'flex flex-col p-background-color-component-colored-background',
	},
})
export class PageWithHeaderComponent {
	@Input() public styleClass: string;

	constructor(public controller: PageWithHeaderController) {}

	public onAvatarChange(e: any) {
		this.controller.updateUserAvatar(e.target.files[0]);
	}
}
